<template>
  <div class="space" />
</template>

<script>
export default {
  name: 'Space',
};
</script>

<style scoped>
  .space {
    height: 14px;
    width: 100%;
  }
</style>
